import { useEffect, useState } from 'react';

export function useAsyncMemo(factory, deps, initial) {
  const [val, setVal] = useState(initial);

  useEffect(() => {
    const promise = factory?.();
    let cancel = false;

    if (promise == null) {
      return;
    }

    promise.then((val) => {
      if (!cancel) {
        setVal(val);
      }
    });

    return () => {
      cancel = true;
    };
  }, [deps, factory]);

  return val;
}
